import { render, staticRenderFns } from "./commentSection.vue?vue&type=template&id=32cf68f6&scoped=true&"
import script from "./commentSection.vue?vue&type=script&lang=js&"
export * from "./commentSection.vue?vue&type=script&lang=js&"
import style0 from "./commentSection.vue?vue&type=style&index=0&id=32cf68f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf68f6",
  null
  
)

export default component.exports